import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import Slot from '@solvhealth/types/interfaces/Location/Slot';
import Location from '@solvhealth/types/interfaces/Location';
import { getAvailableSlots } from '~/components/BookingTimeSelector/Views/components/util';

interface Props {
  slots: Slot[];
  selectedSlots: Slot[];
  location: Location;
  handleSelectSlot: (slot: Slot, location: Location) => void;
  disabled?: boolean;
}

/**
 * This custom hook calls handleSelectSlot on the first available slot whenever no slots are selected
 * or a slot that is selected is no longer available.
 */
export default ({ handleSelectSlot, location, selectedSlots, slots, disabled }: Props) => {
  useEffect(() => {
    if (!disabled) {
      const shouldResetDefaultSlot =
        isEmpty(selectedSlots) ||
        selectedSlots?.some(
          (selectedSlot) =>
            !slots.find((slot: any) => slot.appointmentDate === selectedSlot.appointmentDate)
        );
      // we need to reset default selected slot when selected slot is no longer available
      if (shouldResetDefaultSlot) {
        const defaultSlot = getAvailableSlots(slots)?.[0];
        if (defaultSlot) {
          handleSelectSlot(defaultSlot, location);
        }
      }
    }
  }, [disabled, handleSelectSlot, location, selectedSlots, slots]);
};
